function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getColor } from '../../utils/colorUtils';
import { boxShadow, mediaQuery } from '../../utils/styleUtils';
import { createStyles } from '../../utils/styleUtils/createStyles';
// change layout for devices with smaller screens (height),
// but may also improve taller screens when keyboard is open
const lowHeightMediaQuery = '@media (max-height: 400px)';
const defaultMaxWidth = '500px';
export const useStyles = createStyles((theme, params)=>{
    var _getColor, _params_maxWidth, _getColor1, _params_maxWidth1;
    return {
        root: {
            label: 'BottomSheet-root',
            position: 'fixed',
            top: 0,
            left: 0,
            // keeps the height of the root element in sync with the visual viewport.
            // e.g. when iOS Safari displays a Smart App Banners.
            // solution is connected to `max-height` in ".content" further down.
            height: [
                '100%',
                'calc(var(--vh, 1vh) * 100)'
            ],
            width: '100%',
            zIndex: params.zIndex ? theme.zIndex[params.zIndex] : theme.zIndex.modal,
            touchAction: 'none',
            pointerEvents: 'all',
            overscrollBehavior: 'none',
            WebkitTapHighlightColor: 'transparent',
            WebkitTouchCallout: 'none'
        },
        backdrop: {
            label: 'BottomSheet-backdrop',
            touchAction: 'none',
            pointerEvents: 'all',
            overscrollBehavior: 'none',
            WebkitTapHighlightColor: 'transparent',
            WebkitTouchCallout: 'none',
            position: 'absolute',
            zIndex: 10,
            backgroundColor: theme.color.overlayPrimary,
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            willChange: 'opacity',
            backdropFilter: 'blur(6px)'
        },
        sheet: _object_spread_props(_object_spread({
            label: 'BottomSheet-sheet',
            pointerEvents: 'all',
            overscrollBehavior: 'none',
            WebkitTapHighlightColor: 'transparent',
            WebkitTouchCallout: 'none',
            backgroundColor: (_getColor = getColor(params.backgroundColor, theme)) !== null && _getColor !== void 0 ? _getColor : theme.color.backgroundSecondary,
            position: params.disableBackdrop ? 'fixed' : 'absolute',
            // add some cushion underneath the sheet so that the "drag up rubberband" effect
            // doesn't show the background overlay
            paddingBottom: '150px',
            bottom: '-150px',
            right: 0,
            left: 0,
            zIndex: params.zIndex ? theme.zIndex[params.zIndex] : theme.zIndex.modal,
            backfaceVisibility: 'hidden',
            margin: '0 auto',
            maxWidth: (_params_maxWidth = params.maxWidth) !== null && _params_maxWidth !== void 0 ? _params_maxWidth : defaultMaxWidth,
            overflow: 'hidden',
            borderTopRightRadius: theme.borderRadius.xxl,
            borderTopLeftRadius: theme.borderRadius.xxl
        }, params.disableBackdrop && {
            boxShadow: boxShadow({
                level: 'm',
                color: theme.color.shadowPrimary
            })
        }), {
            [mediaQuery('l')]: {
                backgroundColor: 'transparent',
                display: 'flex !important',
                alignItems: 'center',
                justifyContent: 'center',
                paddingBottom: 0,
                bottom: 0,
                top: 0,
                maxWidth: 'none',
                pointerEvents: 'none'
            },
            // change layout for devices with smaller screens (height),
            // but may also improve taller screens when keyboard is open
            [lowHeightMediaQuery]: {
                maxHeight: `calc(var(--vh, 1vh) * 100 - ${theme.space.l}px)`,
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                overscrollBehavior: 'none',
                touchAction: 'auto',
                paddingBottom: 0,
                bottom: 0
            }
        }),
        content: _object_spread_props(_object_spread({
            label: 'BottomSheet-content',
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridTemplateRows: 'auto 1fr auto',
            gridTemplateAreas: `
      'header'
      'main'
      'footer'`,
            touchAction: 'auto',
            WebkitOverflowScrolling: 'touch',
            overscrollBehavior: 'none',
            // mobile browsers nowadays sets the 1vh value to a fixed value, which means that it will be wrong
            // when users scroll the page and chrome elements disappear (address bar, orientation change etc).
            // we combat this by continually updating a custom property `--vh` to the current value.
            // see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
            maxHeight: [
                '90vh',
                params.maxHeight ? `min(${params.maxHeight}, calc(var(--vh, 1vh) * 100 - ${theme.space.l}px))` : `calc(var(--vh, 1vh) * 100 - ${theme.space.l}px)`
            ],
            paddingBottom: 'env(safe-area-inset-bottom, 0)',
            // bg color is needed here when on ios device and has a safe-area-inset-bottom
            backgroundColor: (_getColor1 = getColor(params.backgroundColor, theme)) !== null && _getColor1 !== void 0 ? _getColor1 : theme.color.backgroundSecondary
        }, params.snapTo === 'full' && {
            height: `calc(var(--vh, 1vh) * 100 - ${theme.space.l}px)`
        }), {
            [mediaQuery('l')]: {
                width: '100%',
                maxWidth: (_params_maxWidth1 = params.maxWidth) !== null && _params_maxWidth1 !== void 0 ? _params_maxWidth1 : defaultMaxWidth,
                borderRadius: theme.borderRadius.xxl,
                overflow: 'hidden',
                pointerEvents: 'all',
                boxShadow: boxShadow({
                    level: 'l',
                    color: theme.color.shadowSecondary
                })
            },
            // change layout for devices with smaller screens (height),
            // but may also improve taller screens when keyboard is open
            [lowHeightMediaQuery]: {
                display: 'block',
                maxHeight: 'none',
                backgroundColor: 'transparent'
            }
        })
    };
});
